import React, { Component } from "react";
import classnames from "classnames";

import { Icon, IconSize } from "@formant/ui/component/common/Icon";

import styles from "./Help.module.scss";
import { IconButton } from "./IconButton";

export interface IHelpProps {
    text: string;
    className?: string;
    to?: string;
    size?: IconSize;
    color?: string;
}

export class Help extends Component<IHelpProps> {
    public render() {
        const { text, className, to, size, color } = this.props;

        return (
            (to && (
                <IconButton
                    icon="help"
                    data-tooltip={text}
                    className={classnames(styles.help, className)}
                    to={to}
                    size={size}
                    target="_blank"
                />
            )) || (
                <Icon
                    name="help"
                    data-tooltip={text}
                    size={size}
                    color={color}
                    className={classnames(styles.help, className)}
                />
            )
        );
    }
}
